import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component, EventEmitter,
	Input,
	OnChanges,
	OnInit, Output,
	SimpleChanges
} from "@angular/core";
import {ISelectableItem} from "../list.selection.item/list.item.component";

@Component({
	selector:'cp-list-selection-with-summary',
	templateUrl: './list.selection.with.summary.template.html',
	styleUrls: ['./list.selection.with.summary.style.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class ListSelectionWithSummaryComponent implements OnInit, OnChanges {
	@Input() allData: ISelectableItem[] = [];
	@Output() dataSelected = new EventEmitter();

	public unselectedData: ISelectableItem[] = [];
	public selectedData: ISelectableItem[] = [];

	constructor() { }

	ngOnInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges) {
		this.refreshItems();
	}

	public handleAdd(addedItems: ISelectableItem[]) {
		addedItems.forEach(item => item.selected = true);
		this.refreshItems();
		this.dataSelected.emit();
	}

	public handleRemove(removedItems: ISelectableItem[]) {
		removedItems.forEach(item => item.selected = false);
		this.refreshItems();
		this.dataSelected.emit();
	}

	private refreshItems() {
		this.selectedData = [];
		this.unselectedData = [];

		this.allData.forEach(item => {
			if (item.selected) {
				this.selectedData.push(item);
			} else {
				this.unselectedData.push(item);
			}
		});
	}
}
